<template>

        <div  id="actdetail">
           <div class="fflex fflexV fflexbet" style="padding: 0 0.2rem 0.3rem">
               <div class="fflex fflexV"><img style="width: 0.52rem" src="/static/qmsj/img/time.png" alt="">
                   <span style="font-size:15px;padding-left: 0.2rem ">6.1儿童节活动 <span style="font-size: 12px">(会员活动)</span></span>
               </div>
               <div class="cirBox">
                   <el-input
                           class="yuaninp"

                           style="width: 4rem"
                           size="mini"
                           placeholder="请输入姓名，电话搜索"

                   >

                       <i  class="el-icon-search el-input__icon"
                           slot="suffix"
                           v-on:click="searchname">
                       </i>
                   </el-input>
               </div>


           </div>


            <div class="fflex fflexC" style="margin-bottom: 0.3rem">

                <div class="fflex boxshadow">
                    <div class="fflex fflexC fflexV" style="width: 4.5rem;text-align: center">
                        总浏览量：<span style="color:#E6BE8A;font-size: 16px;font-weight: bold ">119,300</span>
                    </div>
                    <div class="listd">
                        <p> <span class="land qianz"></span> 参与人数</p>
                        <p class="listbot">119300</p>
                    </div>
                    <div class="listd">
                        <p> <span class="land qianz"></span> 预约人数</p>
                        <p class="listbot">119300</p>
                    </div>
                    <div class="listd">
                        <p> <span class="land qianz"></span> 耗课数量</p>
                        <p class="listbot">119300</p>
                    </div>
                    <div class="listd">
                        <p> <span class="land qianz"></span> 领取奖品总数</p>
                        <p class="listbot">119300</p>
                    </div>
                    <div class="listd">
                        <p> <span class="land qianz"></span> 分享总数</p>
                        <p class="listbot">119300</p>
                    </div>
                </div>

            </div>

            <div class="tableBox" >
                <table class="table table-bordered"  >
                    <thead>
                    <tr>

                        <th>序号</th>
                        <th>姓名</th>
                        <th>会员姓名</th>
                        <th>电话</th>
                        <th>商品兑换</th>
                        <th>耗课总数</th>
                        <th>分享总数</th>
                        <th>状态</th>

                    </tr>
                    </thead>
                    <tbody>
                    <tr >
                        <td>序号</td>
                        <td>姓名</td>
                        <td>会员姓名</td>
                        <td>电话</td>
                        <td>商品兑换</td>
                        <td>耗课总数</td>
                        <td>分享总数</td>
                        <td>状态</td>
                    </tr>


                    </tbody>
                </table>
                <p>共有4条记录  当前1页/共1页</p>

                <div class="table-bottom" style="margin-bottom: 0.2rem">
                    <div>
                        <el-pagination
                                @current-change="fanye"
                                :current-page="currentpage"
                                :page-size="pageone"
                                background
                                layout="prev, pager, next"
                                :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>




        </div>



</template>

<script>

export default {
    data() {
        return {
            currentpage:1,
            pageone:10,
            total:100,

        }
    },
    methods:{
        searchname:function () {
            alert(1)

        },
        jump:function (e,id) {
          this.$router.push({
              name:e,
              queray:{
                  id:id
              }
          })
        },
        fanye:function (i) {
            alert(i)
        }

    },
    filters:{

    },
    watch:{  //watch()监听某个值（双向绑定）的变化，从而达到change事件监听的效果

    },

    mounted:function () {
        console.log(this.$route.query.id)



    }


}
</script>

<style scoped>
    .xiala{
        width: 140px;
        height: 28px;
        line-height: 28px;
        background-color: #fff;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: 13px;
        outline: 0;
        padding: 0 15px;
        -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        transition: border-color .2s cubic-bezier(.645,.045,.355,1);

    }

    .listd{
        width: 2.6rem;
        height: 1rem;
        line-height: .4rem;
        padding-top: 0.1rem;
        padding-bottom: 0.1rem;
        text-align: center;
    }
    .listd p{
        border-left: 1px solid #f1f1f1;
    }
    .boxshadow{
        border-radius: 0.2rem;
         box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    }
    .listbot{
        font-size: 13px;
        font-weight: bold;
    }
    .land {
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 5px;
        margin-right: 0.1rem;
    }
    .qianz {
        background: #f1f1f1;
    }
    #actdetail,  #actdetail *{
    box-sizing: border-box;
    }
  #actdetail{
      font-size: 13px;
      padding: 0.2rem;
      color: #666;
  }
    #actdetail p,ul,label{
        margin: 0;
        padding: 0;
    }
    .fflex{ display: flex}
  .fflexV {
        align-items: center;
    }
    .fflexC{
        justify-content: center;
    }
  .fflexbet{
      justify-content:space-between;
  }
    .qianzBtn{
        background: #f1f1f1!important;
        color: #E6BE8A!important;
        height: 28px;
        padding-left:25px;
        padding-right: 25px;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.2);
        /* padding: 12px 23px; */
    }


</style>
<style>
.yuaninp .el-input__inner{
    border-radius: 14px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.2);
}
.yuaninp  .el-input__icon{
        font-size: 20px;
    color: #E6BE8A;

    }
</style>



// WEBPACK FOOTER //
// src/pages/huodong/actdetail.vue